import gql from "graphql-tag";
import HelperGraphql from "utils/helper-graphql";
import VariablesPagination from 'graphql/variables/VariablesPagination'
import FieldsEmployeeSimple from 'graphql/fields/FieldsEmployeeSimple'

const fields = {
	'search': 'String',
	'department_guid': 'String',
	'team_guid': 'String',
	...VariablesPagination
};

export default gql(`
	query employees( ${ HelperGraphql.createFields( fields ) } ) {
		employees( ${ HelperGraphql.createVariables( fields ) } ) {
			${FieldsEmployeeSimple}
		}
	}
`);
